import React from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col } from "react-bootstrap";

import Header from "./Header";
import Appointments from "./Appointments";
import BarChart from "./BarChart";
import Calendar from "./Calendar";
import Feed from "./Feed";
import PieChart from "./PieChart";
import Projects from "./Projects";
import Statistics from "./Statistics";
import Profile from "./Profile";

const Default = () => (
  <React.Fragment>
    <Helmet title="Default Dashboard" />
    <Container fluid className="p-0">
      <Header />
      <Row>
        <Col md="4" xl="3" className="">
          <Profile />
        </Col>
        <Col md="4" xl="9">
          <Statistics />
          <Row>
            <Col lg="12" className="d-flex">
              <Row>
                <Col md="4" xl="8">
                  <BarChart />
                </Col>
                <Col md="4" xl="4">
                  <Feed />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Projects />
      <Row>
        <Col lg="6" xl="4" className="d-flex">
          <Calendar />
        </Col>
        <Col lg="6" xl="4" className="d-flex">
          <PieChart />
        </Col>
        <Col lg="6" xl="4" className="d-flex">
          <Appointments />
        </Col>
      </Row>
    </Container>
  </React.Fragment>
);

export default Default;
